<label class="form-label" for="name">{{ 'lang.globals.name' |translate }}</label>
<input id="name" name="name" class="form-control" [(ngModel)]="category.name">
<div class="my-2">{{ 'lang.globals.parent'|translate }}</div>
<sb-comp-dropdown-select
  [dropDownDatatype]="'AREA_CATEGORIES'"
  [singleSelectMode]="true" [showSubmit]="false"
  [inputData]="areaCategories"
  (selectedDataEmitter)="update($event, 'AREA_CATEGORIES')" [showColumnIcon]="false"
  [msOptions]="msCategoryOptions" (msOptionsChange)="msRequest('AREA_CATEGORIES', $event)"
  [selectedInputData]="category.parent ? [category.parent] : []">
</sb-comp-dropdown-select>
<div class="row mb-3">
  <div class="col-md-12">
    <div class="form-group d-grid">
      <label class="form-label" for="Company">{{ 'lang.globals.company' | translate }}</label>
      <button [disabled]="isCompanyDisabled" (click)="selectCompany()" type="button" id="Company"
              class="btn btn-secondary  text-center">
        <sb-icon class="mr-1" icon="company"></sb-icon>
        {{ category?.company?.name ?? ('lang.globals.default' | translate) }}
      </button>
    </div>
  </div>
</div>


<div class="d-flex justify-content-end mt-4">
  <button [disabled]="!category.name" (click)=" isInModalContext ? modalNavigationService.result(category) : saveClick.emit(true)"
          class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{ 'lang.globals.save' |translate }}
  </button>
</div>
